import { Check } from 'lucide-react';
import { cn } from '@payment-plan/ui';

const STEPS = ['Plantilla', 'Validar', 'Confirmar'] as const;

export function CatalogSteps({ current }: { current: number }): React.JSX.Element {
  return (
    <ol className="flex flex-wrap items-center gap-3 text-xs">
      {STEPS.map((label, index) => {
        const numero = index + 1;
        const alcanzado = numero <= current;
        return (
          <li key={label} className="flex items-center gap-2">
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full border text-[0.7rem] font-semibold transition-colors',
                alcanzado
                  ? 'border-brand-gold bg-gold-sheen text-brand-gold-dark'
                  : 'border-border text-muted-foreground',
              )}
            >
              {numero < current ? <Check className="h-3 w-3" /> : numero}
            </span>
            <span className={cn(alcanzado ? 'font-medium text-foreground' : 'text-muted-foreground')}>
              {label}
            </span>
            {index < STEPS.length - 1 && <span className="h-px w-8 bg-border" />}
          </li>
        );
      })}
    </ol>
  );
}
